import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { push } from 'connected-react-router';
import { notification } from 'antd';

export const createMarket: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { storeApi },
) =>
  action$.pipe(
    ofType(actions.CREATE_MARKET_ACTIONS.REQUESTED),
    switchMap(({ payload: { market } }) =>
      storeApi.createMarket(market).pipe(
        switchMap(() => of(actions.createMarketSucceeded(), push('/stores'))),
        catchError(error => {
          notification.error({
            message: 'Ошибка при создании магазина',
          });
          console.error('error create', error);
          return of(actions.createMarketFailed(error.message.toString()));
        }),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/CreateStore/services/epics/createMarket.ts